import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private readonly TOKEN_HANDOFF_PROFILE_REFRESH_KEY = 'tokenHandoffProfileRefresh';

    /** True once the current app run has received a successful /api/profile response. */
    sessionBootstrapped = false;

    /** True while a session-expired flow (modal or redirect) is already in progress. */
    sessionExpiredInProgress = false;

    /**
     * Returns the absolute URL of the current page without query string or hash.
     * e.g. https://consumer.noviship.net/shipments
     */
    getCleanUrl(): string {
        return window.location.origin + window.location.pathname;
    }

    /**
     * Returns the app root URL (scheme + host + trailing slash).
     * e.g. https://consumer.noviship.net/
     */
    getAppRootUrl(): string {
        return window.location.origin + '/';
    }

    /** Redirect the browser to the external login page with a redirect_url back to the current clean URL. */
    redirectToLogin(redirectUrl?: string): void {
        const target = redirectUrl ?? this.getCleanUrl();
        window.location.href = `${environment.authUrl}/login?redirect_url=${encodeURIComponent(target)}`;
    }

    /** Redirect the browser to the external logout endpoint with a redirect_url back to the app root. */
    redirectToLogout(): void {
        window.location.href = `${environment.authUrl}/logout?redirect_url=${encodeURIComponent(this.getAppRootUrl())}`;
    }

    /**
     * Redirect the browser to the token-handoff endpoint so the server can
     * establish an HttpOnly cookie and redirect back to the app.
     * @param token  The raw token value from the ?token= query parameter.
     * @param redirectUrl  Where to return after the handoff (defaults to current clean URL).
     */
    redirectToTokenHandoff(token: string, redirectUrl?: string): void {
        sessionStorage.setItem(this.TOKEN_HANDOFF_PROFILE_REFRESH_KEY, '1');
        const target = redirectUrl ?? this.getCleanUrl();
        window.location.href =
            `${environment.authUrl}/token?handoff=${encodeURIComponent(token)}&redirect_url=${encodeURIComponent(target)}`;
    }

    consumeTokenHandoffProfileRefresh(): boolean {
        const shouldRefresh = sessionStorage.getItem(this.TOKEN_HANDOFF_PROFILE_REFRESH_KEY) === '1';
        if (shouldRefresh) {
            sessionStorage.removeItem(this.TOKEN_HANDOFF_PROFILE_REFRESH_KEY);
        }
        return shouldRefresh;
    }

}
